module.exports = __webpack_public_path__ + "media/images/lesson_5/sebastiao_varios_pensamentos-e78cd97aea7b08001315790a3de87d15.svg";